import { CrcMarker, CreMarker } from "./markers"
import { config } from "../../config"

const MapKey = () => {
  return (
    <div className={`${config.namespace}-key`}>
      <strong>Key:</strong>
      <span className={`${config.namespace}-key-item`}><CrcMarker size='small' /> <abbr title='Community Recycling Center' className="nsw-display-inline-block nsw-display-md-none">CRC</abbr> <span className="nsw-display-none nsw-display-md-inline-block">Community Recycling Centre</span></span>
      <span className={`${config.namespace}-key-item`}><CreMarker size='small' /> <abbr title='Chemical Cleanout Event' className="nsw-display-inline-block nsw-display-md-none">CCE</abbr><span className="nsw-display-none nsw-display-md-inline-block">Chemical Cleanout Event</span></span>
    </div>
  )
}

export default MapKey
